import { Button, Group, Modal, Text, Flex, Alert } from '@mantine/core';
import { Widget } from '../../Widgets/types';
import { IconDatabaseExclamation } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

type DeleteConfirmationModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  widget: Widget | null;
};

export default function DeleteConfirmationModal({ opened, onClose, onConfirm, widget }: DeleteConfirmationModalProps ) {
  const { t } = useTranslation( 'widgets' );
  if ( !widget ) return null;
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="md"
      withCloseButton={false}
      trapFocus={false}
    >
      <Flex
        direction="column"
        gap="sm"
        align="stretch" 
      >
        <Alert
          variant="light"
          color="rgba(255, 77, 77, 1)"
          radius="xs"
          title={t( 'delete_confirmation_modal_title','You are about to delete a widget' )}
          icon={<IconDatabaseExclamation />}
        >
          <Text style={{ fontSize: '12px' }} c="dimmed">
            {t( 'delete_confirmation_modal_alert_message','This action cannot be undone. All data associated with this widget will be permanently removed.' )}
          </Text> 
        </Alert>

        <Text size="sm" mt="sm" mb="xs" ta="center" px='sm'>
           {t( 'delete_confirmation_modal_alert_message',`Are you sure you want to delete the widget &apos;${widget.definition.title || 'Untitled Widget'}&apos;` )}?
        </Text>

        <Group grow>
        <Button
          styles={{ inner: { fontSize: '12px' }}}
          size="sm"
          variant="light"
          onClick={onClose}
        >
          {t( 'delete_confirmation_modal_cancel_button', 'Cancel' )}
          </Button>
          <Button
            styles={{ inner: { fontSize: '12px' }}}
            size="sm"
            onClick={onConfirm}
          >
             {t( 'delete_confirmation_modal_confirm_button', 'Delete' )}
          </Button>
        </Group>
      </Flex>
    </Modal>
  );
}